
    ;require("/var/lib/jenkins/workspace/fcom.openapi/FCOM_UAT/fcom.fs2pro/source/$_injectPlugin_21.js");
    
;
    var _regeneratorRuntime = require("/var/lib/jenkins/workspace/fcom.openapi/FCOM_UAT/fcom.fs2pro/source/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/var/lib/jenkins/workspace/fcom.openapi/FCOM_UAT/fcom.fs2pro/source/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncToGenerator");

/* eslint-disable */
require("/var/lib/jenkins/workspace/fcom.openapi/FCOM_UAT/fcom.fs2pro/source/$_mfplugin_virtualInitConfig/index.js");

var _require = require("/var/lib/jenkins/workspace/fcom.openapi/FCOM_UAT/fcom.fs2pro/source/$_mfplugin_virtualSetShared/index.js"),
    setInitShared = _require.setInitShared;

var exposes = {};
module.exports = window["apg_app"] = window["apg_app"] || {
  get: function () {
    var _get = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee(moduleName) {
      var module;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              if (exposes[moduleName]) {
                _context.next = 2;
                break;
              }

              throw new Error("Uncaught Error: Module \"".concat(moduleName, "\" does not exist in container."));

            case 2:
              _context.next = 4;
              return exposes[moduleName]();

            case 4:
              module = _context.sent;
              return _context.abrupt("return", function () {
                return module;
              });

            case 6:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    function get(_x) {
      return _get.apply(this, arguments);
    }

    return get;
  }(),
  // 此处是某个scope之内的shared
  init: function () {
    var _init = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee2(shared) {
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              setInitShared(shared);
              _context2.next = 3;
              return window["__mfplugin__apg_app"].initSharedPromise;

            case 3:
              return _context2.abrupt("return", 1);

            case 4:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));

    function init(_x2) {
      return _init.apply(this, arguments);
    }

    return init;
  }()
};
    